<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" :ssr="false" attach="body" :max-width="300">
    <button class="modal__close" @click="$emit('closed')" v-text="'X'" />

    <div class="modal__content">
      <p>Looks like you've tried to generate a report with the same Google Ads before. Not to worry, please click "connect with google" again to revalidate the necessary permissions and you'll get your report in no time.</p>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
  name: "GoogleConnectionError",
  props: {
    showModal: {
      type: Boolean,
      require: true,
    },
  },
  components: { VueFinalModal },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba($bgLightGray, 0.2);
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 350px;
  max-height: 90%;
  max-width: 90vw;
  margin: 0 1rem;
  border: 1px solid #e2e8f0;
  padding: 2.5rem 3.5rem;
  border-radius: 5px;
  background: #fff;
  transform: translateY(-50px);
  @include mobile {
    padding: 1.5rem 2.5rem;
  }
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
  padding-top: 1.5rem;
  max-width: 500px;

  @include mobile{
    max-width: unset;
  }
  p {
    word-break: break-word;
    max-width: 100%;
  }
}
.modal__close {
  position: absolute;
  top: 2.5rem;
  right: 2.5rem;
  font-weight: bold;
  background: unset;
  border: unset;
  @include mobile{
    padding: 2.5rem 2rem;
  }
}
</style>